import React, { useState, useMemo } from 'react'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import TableHeader from '../UI/TableHeader'
import TicketItem from './Components/TicketItem'
import Snackbar from '../UI/Snackbar'
import TableTopSection from 'UI/TableTopSection'
import DownloadIconButton from 'UI/DownloadIconButton'
import DateInput from './Components/DateInput'
import { getTicketList } from './dummy-data'
import useShallowEqualSelector from 'hooks/global'
import { ApplicationState } from 'Store/intialState'

const Tickets: React.FC = () => {
  const { snackBarCopy, snackBarVisible, loading } = useShallowEqualSelector(
    (state: ApplicationState) => ({
      snackBarCopy: state.ui.snackBarCopy,
      snackBarVisible: state.ui.snackBarVisible,
      loading: state.projects.loading
    })
  )

  const [date, setDate] = useState<Date>()

  const ticketList = useMemo(() => getTicketList(date), [date])

  return (
    <MainContainer>
      <TableContainer>
        <TableTopSection
          title="Tickets"
          loading={loading}
          searchString={`${ticketList.length || 0} Tickets`}
          additionalElement={
            <>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '50px',
                  minWidth: '38px',
                  marginRight: '30px'
                }}
              >
                <a href="/app/tickets/export">
                  <DownloadIconButton onClick={() => {}} />
                </a>
              </div>

              <DateInput date={date} setDate={setDate} />
            </>
          }
        />

        <TableSection>
          <thead>
            <tr>
              {[
                'Date / Time',
                'Ticket',
                'Project',
                'DOTD JMF',
                'Type',
                'Lot',
                'Temp. (℉)',
                'Quantity (t)',
                'Total Shipped (t)',
                'Truck'
              ].map((item, i) => (
                <TableHeader title={item} key={i} />
              ))}
            </tr>
          </thead>
          <tbody>
            {ticketList.map((ticket, index) => {
              return <TicketItem ticket={ticket} key={index} index={index} />
            })}
          </tbody>
        </TableSection>
      </TableContainer>
      {snackBarVisible && <Snackbar text={snackBarCopy} />}
    </MainContainer>
  )
}

export default Tickets
